<template>
  <div class="container">
    <div class="row align-items-center">
      <div
        class="col-12 col-md-12 col-lg-12 text-sm-center"
        :class="{ 'text-center': hideMenu, 'col-xl-3': !hideMenu }"
      >
        <a href="https://dropsmart.io" class="logo">
          <img src="../assets/images/dropsmart-logo.png" alt />
        </a>
      </div>
      <div class="col-md-8 col-lg-9 hide-small" v-if="!hideMenu">
        <b-navbar class="navbar-global-header">
          <b-navbar-nav>
            <b-nav-item href="https://dropsmart.io/pricing">Pricing</b-nav-item>
            <b-nav-item href="https://dropsmart.io/testimonials"
              >Testimonials</b-nav-item
            >
            <b-nav-item href="https://dropsmart.io/blog">Blog</b-nav-item>
            <b-nav-item href="https://dropsmart.io/support"
              >Learn & More</b-nav-item
            >
            <b-nav-item href="/sign-up" class="tryfree"
              >Try it for free</b-nav-item
            >
            <b-nav-item href="https://center.dropsmart.io/login" class="login"
              >Log in</b-nav-item
            >
          </b-navbar-nav>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
html,
body,
#app {
  height: 100%;
}
main {
  align-content: space-between;
  display: flex !important;
  flex-wrap: wrap;
  justify-content: center;
  .logo img {
    max-width: 236px;
    width: 100%;
  }
  .container {
    .row {
      min-height: 110px;
    }
  }
}
.navbar-global-header {
  font-size: 18px;
  padding: 0 !important;
  justify-content: flex-end !important;
  li {
    align-self: center;
  }
  a {
    color: #000000 !important;
    line-height: 42px;
    padding: 0 25px !important;
    &:hover {
      color: #79b867 !important;
    }
  }
}
.tryfree a {
  background: #79b867;
  border: 2px solid #79b867;
  border-radius: 30px;
  color: #ffffff !important;
  font-weight: 700;
  line-height: 42px;
  margin: 0 5px;
  padding: 0 20px !important;
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff !important;
  }
}
.login a {
  border-radius: 30px;
  border: 2px solid #79b867;
  color: #79b867 !important;
  line-height: 42px;
  min-width: 170px;
  padding: 0 45px !important;
  text-align: center;
  &:hover {
    background: #79b867;
    color: #ffffff !important;
  }
}
@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    .row {
      max-width: 1260px !important;
    }
  }
}
@media screen and (max-width: 1199px) {
  .container {
    .row {
      min-height: 110px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
  }
  .hide-small {
    display: none;
  }
}
@media screen and (min-width: 1140px) {
  .hide-lg {
    display: none;
  }
}
@media screen and(min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 100% !important;
    .row {
      max-width: 1230px !important;
      margin: 0 auto;
    }
  }
}
</style>

<script>
export default {
  name: "Header",
  props: ["hideMenu"],
};
</script>
